export const createMenu = /* GraphQL */ `
  mutation CreateMenu(
    $input: CreateMenuInput!
    $condition: ModelMenuConditionInput
  ) {
    createMenu(input: $input, condition: $condition){
      id
    }
  }
`;
export const updateMenu = /* GraphQL */ `
  mutation UpdateMenu(
    $input: UpdateMenuInput!
    $condition: ModelMenuConditionInput
  ) {
    updateMenu(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteMenu = /* GraphQL */ `
  mutation DeleteMenu(
    $input: DeleteMenuInput!
    $condition: ModelMenuConditionInput
  ) {
    deleteMenu(input: $input, condition: $condition) {
      id
    }
  }
`;

export const createItemMaster = /* GraphQL */ `
  mutation CreateItemMaster($createItemMaster: AWSJSON) {
    createItemMaster(createItemMaster: $createItemMaster)
  }
`;
export const updateItemMaster = /* GraphQL */ `
  mutation UpdateItemMaster($updateItemMaster: AWSJSON) {
    updateItemMaster(updateItemMaster: $updateItemMaster)
  }
`;
export const deleteItemMaster = /* GraphQL */ `
  mutation DeleteItemMaster($id: Int) {
    deleteItemMaster(id: $id)
  }
`;
export const createWarehouse = /* GraphQL */ `
  mutation CreateWarehouse(
    $input: CreateWarehouseInput!
    $condition: ModelWarehouseConditionInput
  ) {
    createWarehouse(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateWarehouse = /* GraphQL */ `
  mutation UpdateWarehouse(
    $input: UpdateWarehouseInput!
    $condition: ModelWarehouseConditionInput
  ) {
    updateWarehouse(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteWarehouse = /* GraphQL */ `
  mutation DeleteWarehouse(
    $input: DeleteWarehouseInput!
    $condition: ModelWarehouseConditionInput
  ) {
    deleteWarehouse(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createLocation = /* GraphQL */ `
  mutation CreateLocation(
    $input: CreateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    createLocation(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateLocation = /* GraphQL */ `
  mutation UpdateLocation(
    $input: UpdateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    updateLocation(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteLocation = /* GraphQL */ `
  mutation DeleteLocation(
    $input: DeleteLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    deleteLocation(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createJob = /* GraphQL */ `
  mutation CreateJob($createJob: JobInput) {
    createJob(createJob: $createJob)
  }
`;
export const updateJob = /* GraphQL */ `
  mutation UpdateJob($updateJob: JobInput) {
    updateJob(updateJob: $updateJob)
  }
`;
export const createJob2 = /* GraphQL */ `
  mutation CreateJob2($createJob: AWSJSON) {
    createJob2(createJob: $createJob)
  }
`;
export const updateJob2 = /* GraphQL */ `
  mutation UpdateJob2($updateJob: AWSJSON) {
    updateJob2(updateJob: $updateJob)
  }
`;
export const deleteJob = /* GraphQL */ `
  mutation DeleteJob($id: Int) {
    deleteJob(id: $id)
  }
`;
export const createJobDetail = /* GraphQL */ `
  mutation CreateJobDetail($createJobDetail: JobDetailInput) {
    createJobDetail(createJobDetail: $createJobDetail)
  }
`;
export const updateJobDetail = /* GraphQL */ `
  mutation UpdateJobDetail($updateJobDetail: JobDetailInput) {
    updateJobDetail(updateJobDetail: $updateJobDetail)
  }
`;
export const deleteJobDetail = /* GraphQL */ `
  mutation DeleteJobDetail($id: Int) {
    deleteJobDetail(id: $id)
  }
`;
export const createItemDefine = /* GraphQL */ `
  mutation CreateItemDefine(
    $input: CreateItemDefineInput!
    $condition: ModelItemDefineConditionInput
  ) {
    createItemDefine(input: $input, condition: $condition) {
      tenantId
      source
      name
      inputType
      sourceTable
      order
      group
    }
  }
`;
export const updateItemDefine = /* GraphQL */ `
  mutation UpdateItemDefine(
    $input: UpdateItemDefineInput!
    $condition: ModelItemDefineConditionInput
  ) {
    updateItemDefine(input: $input, condition: $condition) {
      tenantId
      source
      name
      inputType
      showOnApp
      searchOnApp
      group
    }
  }
`;
export const deleteItemDefine = /* GraphQL */ `
  mutation DeleteItemDefine(
    $input: DeleteItemDefineInput!
    $condition: ModelItemDefineConditionInput
  ) {
    deleteItemDefine(input: $input, condition: $condition) {
      source
    }
  }
`;
export const initTenant = /* GraphQL */ `
  mutation InitTenant($tenant: InitTenantInput) {
    initTenant(tenant: $tenant)
  }
`;
export const updateTenant = /* GraphQL */ `
  mutation UpdateTenant(
    $input: UpdateTenantInput!
    $condition: ModelTenantConditionInput
  ) {
    updateTenant(input: $input, condition: $condition) {
      tenantId
    }
  }
`;
export const createMenuConfig = /* GraphQL */ `
  mutation CreateMenuConfig(
    $input: CreateMenuConfigInput!
    $condition: ModelMenuConfigConditionInput
  ) {
    createMenuConfig(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateMenuConfig = /* GraphQL */ `
  mutation UpdateMenuConfig(
    $input: UpdateMenuConfigInput!
    $condition: ModelMenuConfigConditionInput
  ) {
    updateMenuConfig(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteMenuConfig = /* GraphQL */ `
  mutation DeleteMenuConfig(
    $input: DeleteMenuConfigInput!
    $condition: ModelMenuConfigConditionInput
  ) {
    deleteMenuConfig(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateTenantSystemId = /* GraphQL */ `
  mutation UpdateTenantSystemId($systemId: Int) {
    updateTenantSystemId(systemId: $systemId)
  }
`;
export const deleteLocationTag = /* GraphQL */ `
  mutation DeleteLocationTag(
    $input: DeleteLocationTagInput!
    $condition: ModelLocationTagConditionInput
  ) {
    deleteLocationTag(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createLocationTag = /* GraphQL */ `
  mutation CreateLocationTag(
    $input: CreateLocationTagInput!
    $condition: ModelLocationTagConditionInput
  ) {
    createLocationTag(input: $input, condition: $condition) {
      tenantId
      id
      warehouseId
      location_id
      epc
      x
      y
      group
      createdAt
      updatedAt
    }
  }
`;
export const updateLocationTag = /* GraphQL */ `
  mutation UpdateLocationTag(
    $input: UpdateLocationTagInput!
    $condition: ModelLocationTagConditionInput
  ) {
    updateLocationTag(input: $input, condition: $condition) {
      tenantId
      id
      warehouseId
      location_id
      epc
      x
      y
      group
      createdAt
      updatedAt
    }
  }
`;
export const generateAutoNumber = /* GraphQL */ `
  mutation GenerateAutoNumber($numberKey: String) {
    generateAutoNumber(numberKey: $numberKey)
  }
`;

export const deleteAppItemConfig = /* GraphQL */ `
  mutation DeleteAppItemConfig(
    $input: DeleteAppItemConfigInput!
    $condition: ModelAppItemConfigConditionInput
  ) {
    deleteAppItemConfig(input: $input, condition: $condition) {
      id
    }
  }
`;

export const createAppItemConfig = /* GraphQL */ `
  mutation CreateAppItemConfig(
    $input: CreateAppItemConfigInput!
    $condition: ModelAppItemConfigConditionInput
  ) {
    createAppItemConfig(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateAppItemConfig = /* GraphQL */ `
  mutation UpdateAppItemConfig(
    $input: UpdateAppItemConfigInput!
    $condition: ModelAppItemConfigConditionInput
  ) {
    updateAppItemConfig(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteStocks = /* GraphQL */ `
mutation deleteStocks($conditions: AWSJSON) {
    deleteStocks(conditions: $conditions)
  }
`;

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $username: String
    $password: String
    $email: String
    $description: String
    $groupname: String
  ) {
    createUser(
      username: $username
      password: $password
      email: $email
      description: $description
      groupname: $groupname
    )
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser($username: String) {
    deleteUser(username: $username)
  }
`;

export const updateCustomerMaster = /* GraphQL */ `
  mutation UpdateCustomerMaster($tableName: String, $master: AWSJSON) {
    updateCustomerMaster(tableName: $tableName, master: $master)
  }
`;
export const deleteCustomerMaster = /* GraphQL */ `
  mutation DeleteCustomerMaster($tableName: String, $master: AWSJSON) {
    deleteCustomerMaster(tableName: $tableName, master: $master)
  }
`;
export const updateStocks = /* GraphQL */ `
  mutation UpdateStocks($stockList: [AWSJSON]) {
    updateStocks(stockList: $stockList)
  }
`;

export const updateStocks2 = /* GraphQL */ `
  mutation updateStock2($data:AWSJSON,$condition:AWSJSON) {
    updateStock2(data:$data,condition:$condition)
  }
`;

export const createUserAuthManage = /* GraphQL */ `
  mutation CreateUserAuthManage(
    $input: CreateUserAuthManageInput!
    $condition: ModelUserAuthManageConditionInput
  ) {
    createUserAuthManage(input: $input, condition: $condition) {
      tenantId
      username
      menuId
      mapId
      auth
      group
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserAuthManage = /* GraphQL */ `
  mutation UpdateUserAuthManage(
    $input: UpdateUserAuthManageInput!
    $condition: ModelUserAuthManageConditionInput
  ) {
    updateUserAuthManage(input: $input, condition: $condition) {
      tenantId
      username
      menuId
      mapId
      auth
      group
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserAuthManage = /* GraphQL */ `
  mutation DeleteUserAuthManage(
    $input: DeleteUserAuthManageInput!
    $condition: ModelUserAuthManageConditionInput
  ) {
    deleteUserAuthManage(input: $input, condition: $condition) {
      tenantId
      username
      menuId
      mapId
      auth
      group
      createdAt
      updatedAt
      __typename
    }
  }
`;
